import { WindowTitleBar, WindowContent } from "desktopWindow/components/DesktopWindow";
import { ToolBar } from "./component";
import { useNote } from "./helpers";
import Notes from "./Notes";
import { ActionBar } from "desktopWindow/components/DesktopWindow.styled";
import NoteIcon from "../../../assets/img/game-room/note.png";
import { Box, IconButton, Typography } from "@mui/material";
import { ReactComponent as EditIcon } from "assets/svg/game-email-edit.svg";
import { isMobile } from "react-device-detect";

export const NotesViewer = ({ size }) => {
	const {
		notes,
		selectedNote,
		allowedEdit,
		handleNoteSelect,
		onTextChange,
		handleDeleteNote,
		handleCreateNote,
		handleEditNoteFeature,
	} = useNote();

	return (
		<>
			<WindowTitleBar icon={<img src={NoteIcon} alt="note" height="30" width="30" />} />
			<ActionBar
				style={{
					paddingLeft: 24,
					paddingRight: isMobile ? 24 : 0,
					justifyContent: isMobile ? "flex-end" : "center",
				}}
			>
				<ToolBar
					handleDeleteNote={handleDeleteNote}
					handleCreateNote={handleCreateNote}
					allowedEdit={allowedEdit}
					handleEditNoteFeature={handleEditNoteFeature}
				/>
			</ActionBar>
			<WindowContent>
				<Notes
					notes={notes}
					selectedNote={selectedNote}
					handleNoteSelect={handleNoteSelect}
					onTextChange={onTextChange}
					allowedEdit={allowedEdit}
					handleEditNoteFeature={handleEditNoteFeature}
				/>
				{/* Show bottom floating bar only in mobile and not when in editing mode */}
				{isMobile && !allowedEdit && (
					<Box
						sx={{
							height: 90,
							width: "100%",
							position: "fixed",
							bottom: 0,
							left: 0,
							backgroundColor: "#F7F7F7",
							display: "flex",
							justifyContent: "center",
						}}
					>
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
								justifyContent: "center",
								position: "relative",
								width: "100%",
							}}
						>
							<Typography sx={{ fontSize: "0.75rem", fontWeight: 500 }}>{notes?.length} notes</Typography>

							<IconButton
								sx={{
									position: "absolute",
									right: "16px",
								}}
								onClick={handleCreateNote}
							>
								<EditIcon />
							</IconButton>
						</Box>
					</Box>
				)}
			</WindowContent>
		</>
	);
};
